<template>
	<div class="stone">
		<svg
			viewBox="0 0 100 100"
			:style="{ transform: 'rotate(' + (d * -90) + 'deg)' }"
		>
			<defs>
				<mask :id="maskId">
					<!-- direction: 0 (east) -->
					<circle
						cx="50"
						cy="50"
						r="25"
						fill="white"
					/>
					<circle
						cx="25"
						cy="25"
						r="25"
						fill="white"
					/>
					<circle
						cx="75"
						cy="25"
						r="25"
						fill="black"
					/>
					<circle
						cx="25"
						cy="75"
						r="25"
						fill="white"
					/>
					<circle
						cx="75"
						cy="75"
						r="25"
						fill="black"
					/>
				</mask>
			</defs>
			<filter :id="lightId">
				<feGaussianBlur
					in="SourceAlpha"
					stdDeviation="3"
					result="blur1"
				/>
				<feSpecularLighting
					result="specOut"
					in="blur1"
					specularExponent="20"
					lighting-color="#bbbbbb"
				>
					<fePointLight
						:x="lightX"
						:y="lightY"
						z="75"
						style="transition: all .2 ease"
					/>
				</feSpecularLighting>
				<feComposite
					in="SourceGraphic"
					in2="specOut"
					operator="arithmetic"
					k1="0"
					k2="1"
					k3="1"
					k4="0"
				/>
			</filter>

			<g
				:fill="fill"
				:filter="'url(#' + lightId + ')'"
				:mask="'url(#' + maskId + ')'"
				class="heart"
			>
				<circle
					cx="25"
					cy="25"
					r="25"
				/>
				<circle
					cx="75"
					cy="25"
					r="25"
				/>
				<circle
					cx="25"
					cy="75"
					r="25"
				/>
				<circle
					cx="75"
					cy="75"
					r="25"
				/>
				<circle
					cx="50"
					cy="50"
					r="25"
				/>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	props: ["gpv"],
	data() {
		const t = new Date().getMilliseconds();
		const r = Math.round(Math.random() * 100000);
		return {
			lightId: `heart-light-${t}-${r}`,
			maskId: `heart-mask-${t}-${r}`
		};
	},
	computed: {
		d() {
			return this.gpv[2];
		},
		dNorm() {
			let t = this.d;
			while (t < 0) t += 4;
			return t % 4;
		},
		p() {
			return this.gpv[3];
		},
		x() {
			return this.gpv[0];
		},
		y() {
			return this.gpv[1];
		},
		fill() {
			return this.p == 1 ? "#333" : "#CCC";
		},
		lightX() {
			return [-25, 100, 100, -25][this.dNorm];
		},
		lightY() {
			return [-25, 0, 100, 125][this.dNorm];
		}
	}
};
</script>

<style lang="scss">
@import "@/scss/sizing.scss";
.stone {
	@include stone-size();
	filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.5));

	svg {
		transform-origin: 50%;
		transition: all 0.1s ease;
	}
}
</style>